var Components = /* @__PURE__ */ ((Components2) => {
  Components2["FORM"] = "form";
  Components2["NO_AVAILABILITY_FOR_DATE"] = "no availability for date empty state";
  Components2["NO_AVAILABILITY_AT_ALL"] = "no availability at all empty state";
  Components2["SLOT"] = "slot";
  Components2["DATE"] = "date";
  Components2["PAGINATION"] = "pagination";
  Components2["SHOW_MORE"] = "show more";
  return Components2;
})(Components || {});
var Actions = /* @__PURE__ */ ((Actions2) => {
  Actions2["LOAD"] = "load";
  Actions2["CLICK"] = "click";
  return Actions2;
})(Actions || {});
var StaffPolicyComponents = /* @__PURE__ */ ((StaffPolicyComponents2) => {
  StaffPolicyComponents2["ASSIGN_RANDOMLY"] = "assign randomly";
  StaffPolicyComponents2["ASSIGN_BY_PRIORITY"] = "assign by priority";
  return StaffPolicyComponents2;
})(StaffPolicyComponents || {});
var StaffPolicySubComponents = /* @__PURE__ */ ((StaffPolicySubComponents2) => {
  StaffPolicySubComponents2["HIGHEST"] = "highest";
  StaffPolicySubComponents2["LOWEST"] = "lowest";
  StaffPolicySubComponents2["SET_PRIORITY"] = "set priority";
  return StaffPolicySubComponents2;
})(StaffPolicySubComponents || {});
const SCHEDULING_FIELD_PAGE_NAME = "scheduling_field";
export {
  Actions,
  Components,
  SCHEDULING_FIELD_PAGE_NAME,
  StaffPolicyComponents,
  StaffPolicySubComponents
};
//# sourceMappingURL=bi-types.js.map
